angular.module('impactx.search').component('ixListTabContainer', {
        bindings: {
            trns: '<',
            showScrollTop: '&',
            updatePageFunction: '&',
            maxPageNumber: '<',
            notGlobal: '<',
            showNumberOfProductRows: "<",
            productPageNumberFilter: "<",
            resetPageNumber: "="
        },
        controller: 'ListTabContainerCtrl',
        controllerAs: 'containerCtrl',
        templateUrl: 'modules/search/templates/list-tab-container.html',
        transclude: true
    }
);